"use strict";

exports.__esModule = true;
exports.RenderDataToComponents = void 0;
var _errors = require("../../common/errors");
var _dataset = require("../../entities/dataset");
var _schema = require("../../entities/schema");
var _config = require("../../entities/config");
var _propEntryMaker = require("./prop-entry-maker");
var _makeDynamicProps = require("./make-dynamic-props");
var _makeValuePresentation = require("./make-value-presentation");
var _makeBehaviorRelatedProps = require("./make-behavior-related-props");
const RenderDataToComponents = ({
  config,
  formatter,
  dataStore,
  errorReporter,
  dataExpression,
  mediaUtils
}) => ({
  dataset,
  connections,
  components
}) => {
  const schema = dataStore.readSchema(dataset.collectionId);
  const referencedCollectionIds = _schema.Schema.getReferencedCollectionIds(schema);
  const referencedSchemas = dataStore.readSchemas(referencedCollectionIds);
  const recordReadOptions = _dataset.Dataset.getReadOptions(dataset);
  const records = dataStore.readRecords(recordReadOptions);
  const currentRecord = getCurrentRecord(dataset, records);
  const connectionsToUpdatedComponents = _config.Config.filterConnectionsByUpdatedComponents(config, connections);
  for (const connection of connectionsToUpdatedComponents) {
    const propEntries = mapValuesToComponentProps({
      connection,
      dataset,
      schema,
      referencedSchemas,
      currentRecord
    }, {
      config,
      formatter,
      dataExpression,
      mediaUtils,
      errorReporter
    });
    const component = components.find(comp => comp.id === connection.compId);
    if (propEntries.length) {
      try {
        component.setData(Object.fromEntries(propEntries));
      } catch (error) {
        errorReporter.report(_errors.CoreError.of('Failed setting data to component', {
          cause: error
        }));
      }
    }
  }
};
exports.RenderDataToComponents = RenderDataToComponents;
const mapValuesToComponentProps = (dataContext, dependencies) => {
  const {
    connection,
    dataset
  } = dataContext;
  const componentProps = [...(0, _makeDynamicProps.makeDynamicProps)(dataContext, dependencies), ...(0, _makeBehaviorRelatedProps.makeBehaviorRelatedProps)(connection, dataset), ...makeExtraProps(connection)];
  for (const [propName, propConnection] of Object.entries(connection.properties)) {
    if (propConnection.properties) {
      const nestedComponentPropEntries = mapValuesToComponentProps({
        ...dataContext,
        connection: propConnection
      }, dependencies);
      componentProps.push([propName, Object.fromEntries(nestedComponentPropEntries)]);
    } else {
      const makePropEntry = (0, _propEntryMaker.propEntryMaker)(({
        valueData: {
          value,
          fieldType
        },
        connection: {
          propName,
          format,
          dataType
        }
      }, dependencies) => [propName, (0, _makeValuePresentation.makeValuePresentation)({
        format,
        dataType,
        fieldType,
        value
      }, dependencies)]);
      const propEntry = makePropEntry({
        ...dataContext,
        connection: {
          ...propConnection,
          propName
        }
      }, dependencies);
      if (propEntry) {
        componentProps.push(propEntry);
      }
    }
  }
  return componentProps;
};
const makeExtraProps = connection => {
  const extraProps = [];
  for (const [name, value] of Object.entries(connection.extraData)) {
    extraProps.push([name, value]);
  }
  return extraProps;
};
const getCurrentRecord = (dataset, records) => {
  const currentRecordIndex = _dataset.Dataset.getCurrentRecordIndex(dataset);
  const currentRecord = records.at(currentRecordIndex);
  return currentRecord;
};
//# sourceMappingURL=render-data-to-components.js.map